import React, { useState } from 'react';
import { Search, Filter, Play, FileText, Video as VideoIcon, Clock, Calendar, FolderOpen, ExternalLink, File, Link as LinkIcon, Star } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { VideoPlayerModal } from '../components/VideoPlayerModal';
import { ArticleViewerModal } from '../components/ArticleViewerModal';
interface Video {
  id: string;
  title: string;
  description: string;
  category: string;
  duration: string;
  dateAdded: string;
  thumbnailUrl: string;
  isRequired?: boolean;
}
interface Article {
  id: string;
  title: string;
  content: string;
  excerpt: string;
  category: string;
  attachedVideoId: string | null;
  images: string[];
  dateAdded: string;
  readTime: string;
  isRequired?: boolean;
}
interface Document {
  id: string;
  title: string;
  description: string;
  folder: string;
  type: 'file' | 'link';
  url: string;
  dateAdded: string;
}
const INITIAL_VIDEOS: Video[] = [{
  id: '1',
  title: 'New Employee Orientation 2024',
  description: 'Complete guide for new hires covering company culture, mission, and values.',
  category: 'Onboarding',
  duration: '15:30',
  dateAdded: '2024-01-15',
  thumbnailUrl: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&q=80',
  isRequired: true
}, {
  id: '2',
  title: 'Using the HR Portal',
  description: 'Step-by-step tutorial on how to navigate and use the employee self-service portal.',
  category: 'Software Training',
  duration: '08:45',
  dateAdded: '2024-01-20',
  thumbnailUrl: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80',
  isRequired: false
}, {
  id: '3',
  title: '2024 Benefits Enrollment Guide',
  description: 'Detailed overview of health, dental, and vision plans for the upcoming year.',
  category: 'Benefits',
  duration: '22:15',
  dateAdded: '2024-02-01',
  thumbnailUrl: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80',
  isRequired: true
}];
const INITIAL_ARTICLES: Article[] = [{
  id: '1',
  title: 'Step-by-Step Guide to Submitting Expense Reports',
  content: '<h2>Introduction</h2><p>This guide will walk you through the process of submitting expense reports.</p>',
  excerpt: 'This guide will walk you through the process of submitting expense reports...',
  category: 'Software Training',
  attachedVideoId: '2',
  images: [],
  dateAdded: '2024-02-15',
  readTime: '5 min read',
  isRequired: true
}];
const INITIAL_FOLDERS = ['Forms & Templates', 'Dialing Scripts', 'Company Policies', 'Lender Sites'];
const INITIAL_DOCUMENTS: Document[] = [{
  id: '1',
  title: 'Phone App',
  description: '',
  folder: 'Forms & Templates',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '2',
  title: 'Conv/FHA CC Auth',
  description: 'Conventional/FHA Credit Card Authorization',
  folder: 'Forms & Templates',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '3',
  title: 'VA CC Auth',
  description: 'VA Credit Card Authorization',
  folder: 'Forms & Templates',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '4',
  title: 'VA Water Test Requirements',
  description: '',
  folder: 'Forms & Templates',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '5',
  title: 'VOE Form',
  description: 'Verification of Employment Form',
  folder: 'Forms & Templates',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '6',
  title: 'Spousal States',
  description: '',
  folder: 'Forms & Templates',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '7',
  title: 'Commercial Loan Scenario Form',
  description: '',
  folder: 'Forms & Templates',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '8',
  title: 'NTB Form',
  description: '',
  folder: 'Forms & Templates',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '9',
  title: 'LF Flow Chart',
  description: 'Process Flow Chart',
  folder: 'Forms & Templates',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '10',
  title: 'Work Schedule',
  description: '',
  folder: 'Forms & Templates',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '11',
  title: 'Self-Employment Income Guide',
  description: '',
  folder: 'Forms & Templates',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '12',
  title: 'Conv Cover Letter',
  description: 'Conventional Loan Cover Letter',
  folder: 'Forms & Templates',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '13',
  title: 'FHA Cover Letter',
  description: 'FHA Loan Cover Letter',
  folder: 'Forms & Templates',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '14',
  title: 'VA Cover Letter',
  description: 'VA Loan Cover Letter',
  folder: 'Forms & Templates',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '15',
  title: 'Script 1 - Dialer Script',
  description: 'Main dialer script',
  folder: 'Dialing Scripts',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '16',
  title: 'Script 2 - The Perfect Pitch',
  description: '',
  folder: 'Dialing Scripts',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '17',
  title: 'Script 3 - ARP Sheet',
  description: '',
  folder: 'Dialing Scripts',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '18',
  title: 'Script 4 - Rejection Chart',
  description: 'Handling objections',
  folder: 'Dialing Scripts',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '19',
  title: 'Script 5 - Script',
  description: '',
  folder: 'Dialing Scripts',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '20',
  title: 'Script 6 - Tips',
  description: 'Sales tips and techniques',
  folder: 'Dialing Scripts',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '21',
  title: 'Script 7 - Cash Cards',
  description: '',
  folder: 'Dialing Scripts',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '22',
  title: 'AML / BSA / KYC Policy',
  description: 'Anti-Money Laundering, Bank Secrecy Act, Know Your Customer',
  folder: 'Company Policies',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '23',
  title: 'Advertising Policy',
  description: '',
  folder: 'Company Policies',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '24',
  title: 'Anti-Predatory Lending Policy',
  description: '',
  folder: 'Company Policies',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '25',
  title: 'Appraisal Operations Policy',
  description: '',
  folder: 'Company Policies',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '26',
  title: 'LO Pipeline Reassignment Policy',
  description: 'Loan Officer Pipeline Reassignment',
  folder: 'Company Policies',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '27',
  title: 'TILA-RESPA TRID Policy',
  description: '',
  folder: 'Company Policies',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '28',
  title: 'Adverse Action Policy',
  description: '',
  folder: 'Company Policies',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '29',
  title: 'Fair Lending Policy',
  description: '',
  folder: 'Company Policies',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '30',
  title: 'Consumer Complaint Policy',
  description: '',
  folder: 'Company Policies',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '31',
  title: 'SAFE Act & Licensing Policy',
  description: '',
  folder: 'Company Policies',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '32',
  title: 'Information Security Policy',
  description: '',
  folder: 'Company Policies',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '33',
  title: 'Business Continuity & Disaster Recovery Plan',
  description: '',
  folder: 'Company Policies',
  type: 'file',
  url: '#',
  dateAdded: '2024-01-01'
}, {
  id: '34',
  title: 'Village Capital',
  description: 'Lender portal',
  folder: 'Lender Sites',
  type: 'link',
  url: 'https://villagecapital.com',
  dateAdded: '2024-01-01'
}, {
  id: '35',
  title: 'Carrington',
  description: 'Lender portal',
  folder: 'Lender Sites',
  type: 'link',
  url: 'https://carringtonmortgage.com',
  dateAdded: '2024-01-01'
}, {
  id: '36',
  title: 'EPM',
  description: 'Lender portal',
  folder: 'Lender Sites',
  type: 'link',
  url: 'https://epmmortgage.com',
  dateAdded: '2024-01-01'
}, {
  id: '37',
  title: 'Rocket Mortgage',
  description: 'Lender portal',
  folder: 'Lender Sites',
  type: 'link',
  url: 'https://rocketmortgage.com',
  dateAdded: '2024-01-01'
}];
const INITIAL_CATEGORIES = ['All', 'Onboarding', 'Software Training', 'HR Policies', 'Benefits', 'Safety', 'Culture'];
type ContentTab = 'videos' | 'articles' | 'documents';
export function EmployeePortal() {
  const [videos] = useState<Video[]>(INITIAL_VIDEOS);
  const [articles] = useState<Article[]>(INITIAL_ARTICLES);
  const [documents] = useState<Document[]>(INITIAL_DOCUMENTS);
  const [folders] = useState<string[]>(INITIAL_FOLDERS);
  const [categories] = useState(INITIAL_CATEGORIES);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');
  const [activeTab, setActiveTab] = useState<ContentTab>('videos');
  const [selectedVideo, setSelectedVideo] = useState<Video | null>(null);
  const [selectedArticle, setSelectedArticle] = useState<Article | null>(null);
  const filteredVideos = videos.filter(v => (selectedCategory === 'All' || v.category === selectedCategory) && (v.title.toLowerCase().includes(searchQuery.toLowerCase()) || v.description.toLowerCase().includes(searchQuery.toLowerCase())));
  const filteredArticles = articles.filter(a => (selectedCategory === 'All' || a.category === selectedCategory) && (a.title.toLowerCase().includes(searchQuery.toLowerCase()) || a.excerpt.toLowerCase().includes(searchQuery.toLowerCase())));
  const filteredDocuments = documents.filter(d => d.title.toLowerCase().includes(searchQuery.toLowerCase()) || d.description.toLowerCase().includes(searchQuery.toLowerCase()));
  const documentsByFolder = folders.reduce((acc, folder) => {
    acc[folder] = filteredDocuments.filter(d => d.folder === folder);
    return acc;
  }, {} as Record<string, Document[]>);
  return <div className="min-h-screen bg-gray-50 pb-12" data-id="element-1248">
      <div className="bg-white border-b border-gray-200" data-id="element-1249">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1250">
          <div data-id="element-1251">
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-1252">
              Employee Resource Center
            </h1>
            <p className="mt-1 text-gray-500" data-id="element-1253">
              Welcome! Browse our library of training videos, articles, and
              important documents.
            </p>
          </div>
          <div className="mt-6 flex gap-1 p-1 bg-gray-100 rounded-lg w-fit" data-id="element-1254">
            <button onClick={() => setActiveTab('videos')} className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-all ${activeTab === 'videos' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-1255">
              <VideoIcon className="w-4 h-4" data-id="element-1256" />
              Videos
              <span className="ml-1 px-1.5 py-0.5 text-xs rounded-full bg-gray-200 text-gray-600" data-id="element-1257">
                {videos.length}
              </span>
            </button>
            <button onClick={() => setActiveTab('articles')} className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-all ${activeTab === 'articles' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-1258">
              <FileText className="w-4 h-4" data-id="element-1259" />
              Articles
              <span className="ml-1 px-1.5 py-0.5 text-xs rounded-full bg-gray-200 text-gray-600" data-id="element-1260">
                {articles.length}
              </span>
            </button>
            <button onClick={() => setActiveTab('documents')} className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-all ${activeTab === 'documents' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-1261">
              <FolderOpen className="w-4 h-4" data-id="element-1262" />
              Quick Links
              <span className="ml-1 px-1.5 py-0.5 text-xs rounded-full bg-gray-200 text-gray-600" data-id="element-1263">
                {documents.length}
              </span>
            </button>
          </div>
          <div className="mt-6 flex flex-col md:flex-row gap-4 items-center justify-between" data-id="element-1264">
            {activeTab !== 'documents' && <div className="flex overflow-x-auto pb-2 md:pb-0 gap-2 w-full md:w-auto no-scrollbar" data-id="element-1265">
                {categories.map(cat => <button key={cat} onClick={() => setSelectedCategory(cat)} className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${selectedCategory === cat ? 'bg-orange-600 text-white shadow-md shadow-orange-200' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} data-id="element-1266">
                    {cat}
                  </button>)}
              </div>}
            <div className={`relative w-full ${activeTab === 'documents' ? '' : 'md:w-64'}`} data-id="element-1267">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1268">
                <Search className="h-4 w-4 text-gray-400" data-id="element-1269" />
              </div>
              <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-orange-500 focus:border-orange-500 sm:text-sm transition duration-150 ease-in-out" placeholder={`Search ${activeTab}...`} data-id="element-1270" />
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1271">
        {activeTab === 'videos' ? filteredVideos.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-1272">
              {filteredVideos.map(video => <div key={video.id} className="group bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-200 overflow-hidden border border-gray-100 cursor-pointer" onClick={() => setSelectedVideo(video)} data-id="element-1273">
                  <div className="relative aspect-video bg-gray-200 overflow-hidden" data-id="element-1274">
                    <img src={video.thumbnailUrl} alt={video.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-1275" />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center" data-id="element-1276">
                      <div className="w-10 h-10 rounded-full bg-white/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transform scale-75 group-hover:scale-100 transition-all duration-200 shadow-lg" data-id="element-1277">
                        <Play className="w-4 h-4 text-orange-600 ml-0.5" fill="currentColor" data-id="element-1278" />
                      </div>
                    </div>
                    <div className="absolute bottom-2 right-2 px-2 py-1 bg-black/70 rounded text-xs font-medium text-white" data-id="element-1279">
                      {video.duration}
                    </div>
                    {video.isRequired && <div className="absolute top-2 right-2 px-2 py-1 bg-orange-600 rounded text-xs font-bold text-white flex items-center gap-1 shadow-sm" data-id="element-1280">
                        <Star className="w-3 h-3 fill-white" data-id="element-1281" />
                        Required
                      </div>}
                  </div>
                  <div className="p-4" data-id="element-1282">
                    <div className="flex items-start justify-between gap-2 mb-2" data-id="element-1283">
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-orange-50 text-orange-700" data-id="element-1284">
                        {video.category}
                      </span>
                      <span className="text-xs text-gray-400" data-id="element-1285">
                        {new Date(video.dateAdded).toLocaleDateString()}
                      </span>
                    </div>
                    <h3 className="text-sm font-bold text-gray-900 line-clamp-2 group-hover:text-orange-600 transition-colors" data-id="element-1286">
                      {video.title}
                    </h3>
                    <p className="mt-1 text-xs text-gray-500 line-clamp-2" data-id="element-1287">
                      {video.description}
                    </p>
                  </div>
                </div>)}
            </div> : <EmptyState type="videos" onClear={() => {
        setSearchQuery('');
        setSelectedCategory('All');
      }} data-id="element-1288" /> : activeTab === 'articles' ? filteredArticles.length > 0 ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1289">
              {filteredArticles.map(article => {
          const hasVideo = article.attachedVideoId !== null;
          return <div key={article.id} className="group bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-200 overflow-hidden border border-gray-100 cursor-pointer" onClick={() => setSelectedArticle(article)} data-id="element-1290">
                    <div className="p-5" data-id="element-1291">
                      <div className="flex items-start justify-between gap-2 mb-3" data-id="element-1292">
                        <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-orange-50 text-orange-700" data-id="element-1293">
                          {article.category}
                        </span>
                        {hasVideo && <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium bg-blue-50 text-blue-700" data-id="element-1294">
                            <VideoIcon className="w-3 h-3" data-id="element-1295" />
                            Video
                          </span>}
                      </div>
                      <div className="flex items-start justify-between gap-2 mb-2" data-id="element-1296">
                        <h3 className="text-base font-bold text-gray-900 line-clamp-2 group-hover:text-orange-600 transition-colors" data-id="element-1297">
                          {article.title}
                        </h3>
                        {article.isRequired && <div className="flex-shrink-0 px-2 py-1 bg-orange-600 rounded text-xs font-bold text-white flex items-center gap-1 shadow-sm" data-id="element-1298">
                            <Star className="w-3 h-3 fill-white" data-id="element-1299" />
                            Required
                          </div>}
                      </div>
                      <p className="text-sm text-gray-500 line-clamp-3 mb-4" data-id="element-1300">
                        {article.excerpt}
                      </p>
                      <div className="flex items-center gap-4 text-xs text-gray-400" data-id="element-1301">
                        <span className="flex items-center gap-1" data-id="element-1302">
                          <Clock className="w-3.5 h-3.5" data-id="element-1303" />
                          {article.readTime}
                        </span>
                        <span className="flex items-center gap-1" data-id="element-1304">
                          <Calendar className="w-3.5 h-3.5" data-id="element-1305" />
                          {new Date(article.dateAdded).toLocaleDateString()}
                        </span>
                      </div>
                    </div>
                  </div>;
        })}
            </div> : <EmptyState type="articles" onClear={() => {
        setSearchQuery('');
        setSelectedCategory('All');
      }} data-id="element-1306" /> : <div className="space-y-10" data-id="element-1307">
            {folders.map(folder => {
          const folderDocs = documentsByFolder[folder] || [];
          if (searchQuery && folderDocs.length === 0) return null;
          if (folderDocs.length === 0) return null;
          return <div key={folder} className="animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-1308">
                  <div className="flex items-center gap-3 mb-5 border-b border-gray-100 pb-2" data-id="element-1309">
                    <div className="p-1.5 bg-orange-50 rounded-lg" data-id="element-1310">
                      <FolderOpen className="w-5 h-5 text-orange-600" data-id="element-1311" />
                    </div>
                    <h3 className="text-lg font-bold text-gray-900" data-id="element-1312">
                      {folder}
                    </h3>
                    <span className="text-sm font-medium text-gray-400 bg-gray-50 px-2 py-0.5 rounded-full" data-id="element-1313">
                      {folderDocs.length}
                    </span>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-id="element-1314">
                    {folderDocs.map(doc => <a key={doc.id} href={doc.url} target="_blank" rel="noopener noreferrer" className="group relative flex flex-col p-4 bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md hover:border-orange-200 transition-all duration-200 h-full" data-id="element-1315">
                        <div className="flex items-start justify-between mb-3" data-id="element-1316">
                          <div className={`p-2.5 rounded-lg transition-colors ${doc.type === 'link' ? 'bg-blue-50 text-blue-600 group-hover:bg-blue-100' : 'bg-gray-100 text-gray-600 group-hover:bg-gray-200'}`} data-id="element-1317">
                            {doc.type === 'link' ? <LinkIcon className="w-5 h-5" data-id="element-1318" /> : <File className="w-5 h-5" data-id="element-1319" />}
                          </div>
                          <ExternalLink className="w-4 h-4 text-gray-300 group-hover:text-orange-400 transition-colors" data-id="element-1320" />
                        </div>
                        <div className="flex-1" data-id="element-1321">
                          <h4 className="font-semibold text-gray-900 group-hover:text-orange-600 transition-colors line-clamp-2 mb-1.5 leading-tight" data-id="element-1322">
                            {doc.title}
                          </h4>
                          {doc.description && <p className="text-xs text-gray-500 line-clamp-2 leading-relaxed" data-id="element-1323">
                              {doc.description}
                            </p>}
                        </div>
                        <div className="absolute bottom-0 left-0 right-0 h-1 bg-orange-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-200 rounded-b-xl origin-left" data-id="element-1324" />
                      </a>)}
                  </div>
                </div>;
        })}
            {filteredDocuments.length === 0 && <EmptyState type="documents" onClear={() => setSearchQuery('')} data-id="element-1325" />}
          </div>}
      </div>
      <VideoPlayerModal isOpen={!!selectedVideo} onClose={() => setSelectedVideo(null)} video={selectedVideo} data-id="element-1326" />
      <ArticleViewerModal isOpen={!!selectedArticle} onClose={() => setSelectedArticle(null)} article={selectedArticle} videos={videos} onPlayVideo={v => {
      setSelectedArticle(null);
      setSelectedVideo(v);
    }} data-id="element-1327" />
    </div>;
}
function EmptyState({
  type,
  onClear
}: {
  type: 'videos' | 'articles' | 'documents';
  onClear: () => void;
}) {
  return <div className="text-center py-12" data-id="element-1328">
      <div className="mx-auto h-12 w-12 text-gray-400" data-id="element-1329">
        <Filter className="h-full w-full" data-id="element-1330" />
      </div>
      <h3 className="mt-2 text-sm font-medium text-gray-900" data-id="element-1331">
        No {type} found
      </h3>
      <p className="mt-1 text-sm text-gray-500" data-id="element-1332">
        Try adjusting your search to find what you're looking for.
      </p>
      <Button variant="secondary" className="mt-6" onClick={onClear} data-id="element-1333">
        Clear Search
      </Button>
    </div>;
}